import React, {
    Component,
    Fragment,
} from 'react'

import CitiesFooter from './footer-cities'
import SportnectFooter from './footer-new'

export default class Footer extends Component {
    render = () => (
        <Fragment>
            <CitiesFooter {...this.props} />
            <SportnectFooter {...this.props} />
        </Fragment>
    )
}
